import type { Message } from '../types';

/**
 * Unread tracking (lightweight — no schema change): we persist a "last seen"
 * timestamp per conversation in localStorage. A conversation counts as unread
 * when its last message was sent by someone other than the viewer and is
 * newer than the stored last-seen timestamp. Shared by the host inbox and the
 * traveler trip chat — `markConversationSeen` should be called whenever a
 * thread is opened.
 */
const LAST_SEEN_PREFIX = 'sk_conv_seen_';

export function getLastSeen(conversationId: string): string | null {
  try {
    return localStorage.getItem(LAST_SEEN_PREFIX + conversationId);
  } catch {
    return null;
  }
}

export function markConversationSeen(conversationId: string): void {
  if (!conversationId) return;
  try {
    localStorage.setItem(LAST_SEEN_PREFIX + conversationId, new Date().toISOString());
  } catch {
    /* ignore (private mode / storage full) */
  }
}

export function isConversationUnread(
  conversationId: string,
  lastMessage: Message | null,
  selfId: string,
): boolean {
  if (!conversationId || !lastMessage) return false;
  if (lastMessage.sender === selfId) return false;
  const seen = getLastSeen(conversationId);
  if (!seen) return true;
  return new Date(lastMessage.timestamp).getTime() > new Date(seen).getTime();
}
